module.exports = __webpack_public_path__ + "static/media/tableHandout.fdde89e2.jpeg";